import { createContext, useContext } from 'react';

interface ApiExplorerFieldContext {
  // Determines whether the entire field subtree is nullable
  isNullable: boolean;
}

const ApiExplorerFieldContextInstance = createContext<ApiExplorerFieldContext>({
  isNullable: false,
});

const ApiExplorerFieldContextProvider =
  ApiExplorerFieldContextInstance.Provider;

const useApiExplorerFieldContext = () => {
  return useContext(ApiExplorerFieldContextInstance);
};

export {
  ApiExplorerFieldContextProvider,
  ApiExplorerFieldContextInstance,
  useApiExplorerFieldContext,
  type ApiExplorerFieldContext,
};
